// biome-ignore lint/suspicious/noExplicitAny: Automated migration to Biome
export const chunkIntoN = (arr: any[], n: number) => {
  const size = Math.ceil(arr.length / n);
  // biome-ignore lint/correctness/noUnusedFunctionParameters: Automated migration to Biome
  return Array.from({ length: n }, (v, i) =>
    arr.slice(i * size, i * size + size)
  );
};
